import { Box, createStyles, makeStyles, Theme, useTheme } from "@material-ui/core";
import { PRIMARY_RED, SUCCESS_FILL, WHITE } from "../../../const/colors";
import clsx from "clsx";

interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
    content: string;
    color: 'default' | 'success' | 'error' | 'warning' | 'info';
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
         label: {
            display: 'inline-block',
            padding: '4px 8px',
            fontSize: 14,
            lineHeight: '24px',
            borderRadius: 4,
            color: WHITE,
            fontWeight: 'bold'
        }
    })
);

const Pill = ({content, color, className, ...props} : PillProps) => {
    const classes = useStyles();
    const theme = useTheme();

    const getBackgroundColor = () => {
        switch (color) {
            case 'default':
                return PRIMARY_RED;
            case 'success':
                return SUCCESS_FILL;
            case 'error':
                return theme.palette.error.main;
            case 'warning':
                return theme.palette.warning.main;
            case 'info':
                return theme.palette.info.main;
            default:
                return PRIMARY_RED;
        }
    }

    return(
        <Box
            component={'span'}
            className={
                clsx(classes.label, {
                    [className]: className
                })
            }
            {...props}
            style={{
                backgroundColor: getBackgroundColor(), ...props.style
            }}
        >
            {content}
        </Box>
    )
}

export default Pill;